import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { ConfirmModal } from "../../boxes/ConfirmModal/ConfirmModal";
import styles from "./styles.module.scss";

const Account2FaRequiredModal = ({ isAccount2FaEnabled, history }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!isAccount2FaEnabled) {
      setIsModalOpen(true);
    }
  }, [isAccount2FaEnabled]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    history.push("/logout");
  };

  return (
    isModalOpen && (
      <ConfirmModal
        isOpen={isModalOpen}
        withAlertIcon
        title="Security Update Required"
        onConfirm={closeModal}
        onClose={closeModal}
        onCancel={handleCancel}
        confirmTitle="Setup"
      >
        <div>
          <p>
            Starting now, 2FA is mandatory for all users to help enhance
            security. You will be redirected to the user settings, setup is
            quick and straightforward!{" "}
            <a
              href="https://learn.aestheticrecord.com/en/articles/12332987-turn-on-2fa-two-factor-authentication"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.link}
            >
              Learn more
            </a>
          </p>
        </div>
      </ConfirmModal>
    )
  );
};

function mapStateToProps(state) {
  return {
    isAccount2FaEnabled: state.AccountHoldRedirectReducer.isAccount2FaEnabled,
  };
}

export default connect(mapStateToProps)(withRouter(Account2FaRequiredModal));
